<div id='relatorios'>
  <div class='conteudo-relatorios wrap'>
    <div class="relatorios-box" [ngClass]="{'w-100': card}" *ngFor="let item of arrayRelatorios">

      <div class="d-flex w-100 justify-content-between align-items-center custom-relatorio" >
        <span class=" titulo-relatorio">{{ item.nome }}</span>
        <button *ngIf="jasperService.waitJasper" id="btnModalJasper"
          class='btn d-flex align-items-center' (click)="openJasperReport(item.id)">
          <img src="assets/img/icons/printer.svg" class="me-2" title="Impressora" />
          <span class="custom-font"> Extrair Relatório </span></button>
      </div>
      
    </div>
  </div>
</div>
